import { List, ListItemButton, ListItemText, useMediaQuery, useTheme } from "@mui/material";
import { Box } from "@mui/system";
import { useNavigate } from "react-router";

const ListItems = function ({ items, offset }: any) {
  const theme = useTheme();
  const isMedium = useMediaQuery(theme.breakpoints.up(750));
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        width: 245,
        borderRadius: 0,
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.secondary.main,
        overflow: "hidden",
      }}
    >
      <List sx={{ py: 0 }}>
        {items
          .filter((item: any) => !(item.smallScreens && isMedium))
          .map((item: any) => (
            <ListItemButton key={item.label} onClick={item.onClick || (() => navigate(item.link))}>
              <ListItemText
                sx={{
                  fontSize: 16,
                  letterSpacing: 0.5,
                  color: "secondary",
                  paddingLeft: offset ? "36px" : 0,
                }}
              >
                {item.label}
              </ListItemText>
            </ListItemButton>
          ))}
      </List>
    </Box>
  );
};

export default ListItems;
